import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [commodities, setCommodities] = useParameter<number[]>("@commodities");
  const [commoditiesGroup, setCommoditiesGroup] = useParameter<number[]>("@commodities_groups");

  useEffect(() => {
    setParameters(title, {
      "@commodities": commodities,
      "@commodities_groups": commoditiesGroup,
    });
  }, [title, commodities, commoditiesGroup, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, string[]>) => {
      setCommodities(parameters["@commodities"].map(Number));
      setCommoditiesGroup(parameters["@commodities_groups"].map(Number));
    },
    [setCommodities, setCommoditiesGroup]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);
}
